import { http } from '../request'
import type {
    UserUpdateRequest,
    ChangePasswordRequest,
    UserDetailResponse,
    UserUpdateResponse,
    ChangePasswordResponse
} from '../types/user'


/**
 * 用户相关 API
 */
export const userApi = {
    /**
     * 获取当前用户信息
     * GET /api/user/profile/
     */
    getUserInfo(): Promise<UserDetailResponse> {
        return http.get<UserDetailResponse>('/api/user/profile/')
    },

    /**
     * 更新当前用户信息
     * PUT /api/user/change/
     */
    updateUserInfo(data: UserUpdateRequest): Promise<UserUpdateResponse> {
        return http.put<UserUpdateResponse>('/api/user/change/', data)
    },

    /**
     * 修改密码
     * POST /api/user/change-password/
     */
    changePassword(data: ChangePasswordRequest): Promise<ChangePasswordResponse> {
        return http.post<ChangePasswordResponse>('/api/user/change-password/', data)
    },
}

export default userApi 